import { render, staticRenderFns } from "./checkedList.vue?vue&type=template&id=3794feef"
import script from "./checkedList.vue?vue&type=script&lang=js"
export * from "./checkedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports